export const DASHBOARD_ENDPOINT_KEY = 'dashboard'
